import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiGet, TENANT_TOKEN_KEY } from '../../../api/client';
import { tokens } from '../../../design-system/tokens';

export function OperatorNotificationsBell() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [count, setCount] = useState(0);
  const token = typeof window !== 'undefined' ? localStorage.getItem(TENANT_TOKEN_KEY) : null;

  const refreshCount = useCallback(async () => {
    if (!token) return;
    try {
      const data = await apiGet<{ count: number }>('/api/console/notifications/unread-count', token, {
        showErrorGrowl: false,
      });
      setCount(data.count);
    } catch {
      /* ignorar */
    }
  }, [token]);

  useEffect(() => {
    void refreshCount();
    const id = window.setInterval(() => void refreshCount(), 30_000);
    return () => window.clearInterval(id);
  }, [refreshCount, pathname]);

  useEffect(() => {
    const onUpdated = () => void refreshCount();
    window.addEventListener('va-operator-notifications-updated', onUpdated);
    return () => window.removeEventListener('va-operator-notifications-updated', onUpdated);
  }, [refreshCount]);

  return (
    <button
      type="button"
      data-va-notifications-bell
      onClick={() => navigate('/app/notifications')}
      aria-label="Notificaciones"
      title="Ver notificaciones"
      style={{
        position: 'relative',
        width: 40,
        height: 40,
        borderRadius: 10,
        border: `1px solid ${tokens.semantic.border}`,
        background: tokens.semantic.surface,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: tokens.semantic.textPrimary,
      }}
    >
      <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden>
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {count > 0 && (
        <span
          style={{
            position: 'absolute',
            top: 4,
            right: 4,
            minWidth: 18,
            height: 18,
            padding: '0 5px',
            borderRadius: 999,
            background: tokens.colors.error.main,
            color: '#fff',
            fontSize: 11,
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
}
